export function getParamCaseInsensitive(params: URLSearchParams, name: string): string | null {
    const normalizedName = name.toLowerCase();
    let result: string | null = null;

    params.forEach((value, key) => {
        if (result === null && key.toLowerCase() === normalizedName) {
            result = value;
        }
    })

    return result;
}
